import {
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

interface ConfirmationPopupContentProps {
  className?: string
  title: React.ReactElement
  subtitle: React.ReactElement
  actionButtonLabel: React.ReactElement
  actionButtonOnClick: () => void
  actionButtonLoading: boolean | undefined
  actionButtonDesign?: ButtonDesigns
  cancelButtonLabel?: React.ReactElement
  cancelButtonDesign?: ButtonDesigns
  cancelButtonOnClick?: () => void
  topLevelError?: string
  isCancelButtonLink?: boolean
  actionButtonDisabled?: boolean
  underline?: boolean
}

const ConfirmationPopupContent: React.FC<ConfirmationPopupContentProps> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            32,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 40px;
        `}
      >
        {props.title}
      </span>
      <span
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
          margin-bottom: 40px;
        `}
      >
        {props.subtitle}
      </span>
      {props.topLevelError !== undefined && (
        <span
          css={css`
            margin-bottom: 40px;
            ${getFontCss(
              14,
              styleConstants.colors.red,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          {props.topLevelError}
        </span>
      )}
      <div
        css={css`
          display: flex;
        `}
      >
        <Button
          design={props.actionButtonDesign || ButtonDesigns.designRed}
          type={ButtonTypes.button}
          big={true}
          text={props.actionButtonLabel}
          onClick={props.actionButtonOnClick}
          loading={props.actionButtonLoading}
          disabled={props.actionButtonLoading || props.actionButtonDisabled}
          testId={'confirmBtn'}
        />
        {props.isCancelButtonLink ? (
          <div
            css={css`
              margin-top: 15px;
            `}
          >
            <HoverableLink
              css={css`
                margin-left: 20px;
              `}
              onClick={
                props.cancelButtonOnClick ||
                ((): void => {
                  dispatch(closeModal())
                })
              }
              underline={props.underline !== undefined ? props.underline : true}
              regular
              ariaLabel={props.cancelButtonLabel?.props.source || ''}
              size={HoverableLinkSizes.Large}
              testId={'cancelBtn'}
            >
              {props.cancelButtonLabel}
            </HoverableLink>
          </div>
        ) : (
          <Button
            css={css`
              margin-left: 20px;
            `}
            design={props.cancelButtonDesign || ButtonDesigns.designCtaInverse}
            type={ButtonTypes.button}
            big={true}
            text={props.cancelButtonLabel}
            testId={'cancelBtn'}
            onClick={
              props.cancelButtonOnClick ||
              ((): void => {
                dispatch(closeModal())
              })
            }
          />
        )}
      </div>
    </div>
  )
}

export default ConfirmationPopupContent
